import { useFeature } from "byzantine";

import QuickActionsBar from "../QuickActionsBar";

const QuickActionsBarContainer = () => {
  const { featureEnabled } = useFeature();
  const isQuickActionsEnabled = featureEnabled("enable_quick_actions");

  if (!isQuickActionsEnabled) {
    return null;
  }

  return <QuickActionsBar />;
};

export default QuickActionsBarContainer;
